export default "__VITE_ASSET__BdGj59AM__"